import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export const getLocationsExistence = (
  locations: IMealCredit['locations']
): IMealCreditFormFields['locationsExistence'] => {
  return Object.keys(locations).length === 0 ? 'hasNoLocation' : 'hasLocation';
};
